import { render, staticRenderFns } from "./passport-dialog.vue?vue&type=template&id=c76968ba&scoped=true"
import script from "./passport-dialog.vue?vue&type=script&lang=js"
export * from "./passport-dialog.vue?vue&type=script&lang=js"
import style0 from "./passport-dialog.vue?vue&type=style&index=0&id=c76968ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76968ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c76968ba')) {
      api.createRecord('c76968ba', component.options)
    } else {
      api.reload('c76968ba', component.options)
    }
    module.hot.accept("./passport-dialog.vue?vue&type=template&id=c76968ba&scoped=true", function () {
      api.rerender('c76968ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/entries/components/passport-dialog.vue"
export default component.exports